import React, { useEffect, useState } from "react";
import { Button, Link, Tab } from "../components";
import { CONTACT } from "../constants/routes";
import Parcours from "../fixtures/Parcours.json";

interface IData {
  id: number;
  name: string;
  startDate: number | string;
  endDate: number | string;
  place: string;
  description: string;
}

const ParcoursContainer = () => {
  const [isShow, setIsShow] = useState(false);
  const [dataToShow, setDataToShow] = useState<IData[]>(Parcours.education);

  const hundleClick = () => {
    setIsShow((prev) => !prev);

    if (isShow) {
      setDataToShow(Parcours.education);
    } else {
      setDataToShow(Parcours.experience);
    }
  };

  return (
    <Tab>
      <Tab.Header>
        <Tab.Item active={!isShow} disabled={!isShow} onClick={hundleClick}>
          education
        </Tab.Item>
        <Tab.Item active={isShow} disabled={isShow} onClick={hundleClick}>
          experience
        </Tab.Item>
      </Tab.Header>
      <Tab.Body>
        <Tab.TimeLine>
          {dataToShow.map((item) => (
            <Tab.TimeItem key={item.id}>
              <Tab.Period>
                {item.startDate} - {item.endDate}
              </Tab.Period>
              <Tab.Name>
                {item.name} - <Tab.Place>{item.place}</Tab.Place>
              </Tab.Name>
              <Tab.Desc>{item.description}</Tab.Desc>
            </Tab.TimeItem>
          ))}
        </Tab.TimeLine>
      </Tab.Body>
      <Link to='https://drive.google.com/file/d/1jXpJNcaWEMQRli2wDHwGyZkQl6OfjSFo/view'>
        download CV
      </Link>
      <Button to={CONTACT}>contact me</Button>
    </Tab>
  );
};

export default ParcoursContainer;
